<template>
  <div>
    <a-steps v-model="stepsCurrent" type="navigation" size="small">
      <a-step v-for="item in steps" :key="item.title" :title="item.title" :description="item.desc" disabled />
    </a-steps>
    <a-row style="margin-top: 20px;">
      <!-- 租户信息表单 -->
      <TenantForm v-show="stepsCurrent === 0" ref="tenantForm" actionType="add" normal @ok="saveFormData" />
      <!-- 角色信息表单 -->
      <RoleForm v-show="stepsCurrent === 1" ref="roleForm" @ok="saveFormData" />
      <!-- 用户信息表单 -->
      <UserForm v-show="stepsCurrent === 2" ref="userForm" @ok="saveFormData" />
      <!-- 分配菜单权限 -->
      <MenuAuthForm v-show="stepsCurrent === 3" ref="menuAuthForm" />
    </a-row>
    <a-row style="text-align: center;margin-top: 20px">
      <a-button v-if="stepsCurrent > 0" @click="prev" style="margin-right: 8px">上一步</a-button>
      <a-button v-if="stepsCurrent < steps.length - 1" type="primary" style="margin: 0 8px" @click="next">下一步</a-button>
      <a-button type="primary" v-if="stepsCurrent === steps.length - 1" @click="submitAll">完成</a-button>
    </a-row>
  </div>
</template>

<script>
import TenantForm from '@views/system/modules/TenantForm'
import RoleForm from '@views/system/modules/RoleForm'
import UserForm from '@views/system/modules/UserForm'
import MenuAuthForm from '@views/system/modules/MenuAuthForm'
import { tenantAdd } from '@api/api'

export default {
  name: 'TenantAdd',
  title: '租户新建引导',
  components: { TenantForm, RoleForm, UserForm, MenuAuthForm },
  data() {
    return {
      // 步骤进度
      stepsCurrent: 0,
      steps: [
        {
          title: '租户信息',
          desc: '创建租户基础信息',
          // 组件ref值
          compName: 'tenantForm'
        },
        {
          title: '角色',
          desc: '初始化一个角色',
          // 组件ref值
          compName: 'roleForm'
        },
        {
          title: '用户',
          desc: '初始化一个用户',
          // 组件ref值
          compName: 'userForm'
        },
        {
          title: '菜单',
          desc: '初始化菜单权限',
          // 组件ref值
          compName: 'userForm'
        }
      ],
      // 所有表单数据合集
      formData: {}
    }
  },
  methods: {
    // 点击下一步，校验当前表单信息
    next() {
      let { compName } = this.steps[ this.stepsCurrent ]
      if (!compName) return
      // 调用子组件里的提交方法
      this.$refs[ compName ]?.submitForm()
    },
    // 上一步
    prev() {
      this.stepsCurrent--
    },
    saveFormData(data) {
      this.stepsCurrent++
      this.formData = {
        ...this.formData,
        ...data
      }
    },
    // 最终完成提交
    submitAll() {
      let menuArr = this.$refs.menuAuthForm.checkedKeys
      if (!menuArr.length) return this.$message.warning('请分配菜单权限')
      let params = {
        ...this.formData,
        permissionIds: menuArr.toString()
      }
      tenantAdd(params).then(res => {
        this.$message.success('操作成功')
        this.$emit('success')
      })
    }
  }
}
</script>

<style scoped>

</style>